import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import loadingAnimation from "./Animation.json"; // Import a Lottie animation

const LoadingPage = () => {
  return (
    <div style={styles.container}>
      {/* Lottie Animation */}
      <Player
        autoplay
        loop
        src={loadingAnimation}
        style={styles.animation}
      />
      {/* Loading Text */}
      <h1 style={styles.text}>Loading...</h1>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa", // Subtle background color
    color: "#4A90E2", // Modern blue color for text
    fontFamily: "'Roboto', sans-serif",
  },
  animation: {
    width: "150px",
    height: "150px",
    marginBottom: "20px",
  },
  text: {
    fontSize: "20px",
    fontWeight: "400",
    letterSpacing: "1.2px",
    animation: "fadeIn 2s infinite",
  },
};

export default LoadingPage;
